import React from "react";
import "../printStyles.css";

function GateCheck() {
  return (
    <>
      {/* CSS for print functionality to hide everything but the form */}
      <style>
        {`
          @media print {
            body * {
              visibility: hidden;
            }
            #GateCheckForm, #GateCheckForm * {
              visibility: visible;
            }
            #GateCheckForm {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              margin: 0;
              padding: 0;
              box-shadow: none;
              border: none;
            }
            /* Set up page margins for printing */
            @page {
              size: A4;
              margin: 20mm; /* Add a reasonable margin to prevent content from being cut off */
            }
            .print-button {
              display: none;
            }
          }
        `}
      </style>
      <div id="GateCheckForm" className="p-4 border rounded-lg bg-white shadow-md">
        <h3 className="text-2xl font-semibold mb-4">Gate Check Form</h3>

        <form>
          {/* Vehicle Registration */}
          <div className="mb-4">
            <label className="block text-lg font-medium" htmlFor="vehicleRegistration">
              Vehicle Registration:
            </label>
            <input
              type="text"
              id="vehicleRegistration"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter vehicle registration"
            />
          </div>

          {/* Week Commencing */}
          <div className="mb-4">
            <label className="block text-lg font-medium" htmlFor="weekCommencing">
              Week Commencing:
            </label>
            <input
              type="date"
              id="weekCommencing"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Checked By */}
          <div className="mb-4">
            <label className="block text-lg font-medium" htmlFor="checkedBy">
              Checked By (Name):
            </label>
            <input
              type="text"
              id="checkedBy"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter name"
            />
          </div>

          {/* Date */}
          <div className="mb-4">
            <label className="block text-lg font-medium" htmlFor="date">
              Date:
            </label>
            <input
              type="date"
              id="date"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Items to Check */}
          <div className="mb-6">
            <h4 className="text-xl font-semibold mb-4">Items to Check</h4>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
              {/* Bodywork & Panels */}
              <div className="mb-2">
                <label className="flex items-center space-x-1">
                  <input type="checkbox" className="form-checkbox text-blue-500 h-5 w-5 rounded" />
                  <span className="text-sm">Bodywork & Panels</span>
                </label>
              </div>

              {/* Mirrors & Windows */}
              <div className="mb-2">
                <label className="flex items-center space-x-1">
                  <input type="checkbox" className="form-checkbox text-blue-500 h-5 w-5 rounded" />
                  <span className="text-sm">Mirrors & Windows</span>
                </label>
              </div>

              {/* Security Seals */}
              <div className="mb-2">
                <label className="flex items-center space-x-1">
                  <input type="checkbox" className="form-checkbox text-blue-500 h-5 w-5 rounded" />
                  <span className="text-sm">Security Seals</span>
                </label>
              </div>

              {/* Trailer Coupling */}
              <div className="mb-2">
                <label className="flex items-center space-x-1">
                  <input type="checkbox" className="form-checkbox text-blue-500 h-5 w-5 rounded" />
                  <span className="text-sm">Trailer Coupling</span>
                </label>
              </div>

              {/* PSV Emergency Exits */}
              <div className="mb-2">
                <label className="flex items-center space-x-1">
                  <input type="checkbox" className="form-checkbox text-blue-500 h-5 w-5 rounded" />
                  <span className="text-sm">PSV Emergency Exits</span>
                </label>
              </div>

              {/* Tail Lift (if applicable) */}
              <div className="mb-2">
                <label className="flex items-center space-x-1">
                  <input type="checkbox" className="form-checkbox text-blue-500 h-5 w-5 rounded" />
                  <span className="text-sm">Tail Lift (if applicable)</span>
                </label>
              </div>
            </div>

            {/* Overall Condition */}
            <div className="mt-4">
              <label className="block text-lg font-medium" htmlFor="overallCondition">
                Overall Condition:
              </label>
              <div className="flex space-x-4 mt-2">
                <label className="flex items-center space-x-1">
                  <input type="radio" name="overallCondition" value="allOK" className="form-radio text-blue-500 h-4 w-4" />
                  <span className="text-sm">All OK</span>
                </label>
                <label className="flex items-center space-x-1">
                  <input type="radio" name="overallCondition" value="defectsFound" className="form-radio text-blue-500 h-4 w-4" />
                  <span className="text-sm">Defects Found</span>
                </label>
              </div>
            </div>
          </div>

          {/* Notes Section */}
          <div className="mb-4">
            <label className="block text-lg font-medium" htmlFor="notes">
              Notes:
            </label>
            <textarea
              id="notes"
              className="p-3 border border-gray-300 rounded-lg w-full h-24 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Record any defects found and actions taken"
            />
          </div>

          {/* Print Button */}
          <div className="mb-4 text-right">
            <button
              type="button"
              onClick={() => window.print()}
              className="w-64 bg-blue-500 text-white p-4 rounded-lg hover:bg-blue-600 transition-colors print-button"
            >
              Print Form
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default GateCheck;